"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const app_icon_1 = require("../icons/app_icon");
const app_text_1 = __importDefault(require("../typography/app_text"));
const flex_1 = require("../layout/flex");
const CallState = ({ name, connectionQuality }) => {
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(flex_1.Flex, Object.assign({ px: "12px", height: "24px", bg: "azure", borderRadius: 12, alignItems: "center", justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsx)(app_icon_1.AppIcon, { name: "CallLiveIcon", callQuality: connectionQuality, color: theme.colors.white }), (0, jsx_runtime_1.jsx)(app_text_1.default, Object.assign({ color: "light", size: "medium" }, { children: name }))] })));
};
exports.default = CallState;
//# sourceMappingURL=call_state.js.map